import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatBottomSheet,MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ResourcesService } from '../services/resources.service';
import { ConfirmSnackbarComponent } from '../confirm-snackbar/confirm-snackbar.component';
import { MatDialog } from '@angular/material/dialog';
import { AddnoteDialogComponent } from '../addnote-dialog/addnote-dialog.component';
import { LogService } from '../services/log.service';

@Component({
  selector: 'app-resources-note',
  templateUrl: './resources-note.component.html',
  styleUrls: ['./resources-note.component.css']
})
export class ResourcesNoteComponent implements OnInit {
 
  constructor(public log: LogService, @Optional() @Inject(MAT_BOTTOM_SHEET_DATA)  public data? : any, 
  public _bottomSheetRef?:MatBottomSheetRef<ResourcesNoteComponent>, public _resourcesService?: ResourcesService, public _bottomSheet?: MatBottomSheet, public _dialog?: MatDialog) {
    this.constr = this;
   }

  public allNotes = [];
  public forNote = false;
  public noteInp = " ";
  public constr;
  public noteObj;
  public emptyNote = false;
  public message = "";
  public spinner = true;

  public selectedOption = 0;

  ngOnInit() {
    this.log
      .addLog({
      action: "Access",
      component: "Resources",
      details: `Access & Fetched Resources Note of ${this.data.resource} - ${this.data.topic} - ${this.data.title}`,
    }).subscribe(data => { });
    this.noteObj = this.data;
    this.selectedOption = 0;
    this.selectByLecture();
    // this.getResourceNotes();
  }

  // This get note of a particular(default) resource
  getResourceNotes () {
    this.spinner = true;
    let resourceObj = {resource_id: this.data.resource_id, course_id: this.data.course_id};
    this._resourcesService.getResourcesNote(resourceObj).subscribe(data => {
      this.allNotes = data;
      if (this.allNotes.length <= 0) {
        this.emptyNote = true;
        this.message = `No Note in this lecture yet. You can view all Notes or click "+" to add a Note`;
      } else if(this.allNotes.length != 0) {
        this.emptyNote = false;
        this.message = "";
      }
      this.spinner = false;
    })
  }

  // This gets all note
  getAllNotes () {
    this.spinner = true;
    let resourceObj = {resource_id: "all", course_id: this.data.course_id};
    this._resourcesService.getResourcesNote(resourceObj).subscribe(data => {
      this.allNotes = data;
      if (this.allNotes.length <= 0) {
        this.emptyNote = true;
        this.message = `No Notes in this course yet. Click "+" to add a note`;
      } else if(this.allNotes.length != 0) {
        this.emptyNote = false;
        this.message = "";
      }
      this.spinner = false;
    })
  }

  // This adds note
  addNote () {
    this.spinner = true;
    let dialog = this._dialog.open(AddnoteDialogComponent, {
      data: {video_timestamp: this.data.video_timestamp,resource_id: this.data.resource_id},
      width: '700px'
    })
    dialog.afterClosed().subscribe(response => {
      if (response == "Success") {
        this.getAllNotes();
        this.log
          .addLog({
          action: "Add",
          component: "Resources Note",
          details: `Added Resources Note to resource - ${this.data.resource} - ${this.data.topic} -  - ${this.data.title}`
        }).subscribe(data => { });
      } else if (response == "Failed") {
        this.constr.snackBar.open("Failed", 'Dismiss');
      }
      this.spinner = false;
    })
  }

  // This edit notes
  editNote (note) {
    this.spinner = true;
    let dialog = this._dialog.open(AddnoteDialogComponent, {
      data: {video_timestamp: note.video_timestamp, resource_id: note.resource_id, note: note.note, resource_note_id: note.resource_note_id},
      width: '700px'
    })
    dialog.afterClosed().subscribe(response => {
      if (response == "Failed") {
        this.constr.snackBar.open("Failed", 'Dismiss');
      }
      this.log
        .addLog({
        action: "Edit",
        component: "Resources Note",
        details: `Edited Resources Note in - ${this.data.resource} - ${this.data.topic} - ${this.data.title}`,
      }).subscribe(data => { });
      this.ngOnInit();
      this.spinner = false
    })
  }


  // This function delete a particular resource note
  deleteResourceNote (resource_note_id) {
    this.spinner = true;
    let bottomSheet = this._bottomSheet.open(ConfirmSnackbarComponent, {
      data: {message: "Are you sure you want to delete this note?", button1: 'yes', button2: 'no'}
    })
    bottomSheet.afterDismissed().subscribe(response => {
      if (response.response == true) {
        this._resourcesService.deleteResourceNote(resource_note_id).subscribe(data => {
          if (data.success != true) {
            this.constr.snackBar.open('Unable to delete Note', 'Dismiss')
          }
          this.log
            .addLog({
            action: "Delete",
            component: "Resources Note",
            details: `Deleted Resources Note in - ${this.data.resource} - ${this.data.topic}  - ${this.data.title}`,
          }).subscribe(data => { });
          this.ngOnInit();   
          this.spinner = false;
        }) 
      } 
      this._bottomSheet.open(ResourcesNoteComponent, {
        data: {video_timestamp: this.noteObj.video_timestamp, resource_id: this.noteObj.resource_id, course_id: this.noteObj.course_id}
      });
    })
  }

  selectByLecture() {
    this.message = "";
    // 0 for the default lecture and 1 for all lecture/resource
    if (this.selectedOption == 0) {
      this.getResourceNotes();
    } else if (this.selectedOption == 1) {
      this.getAllNotes();
    }
  }

}
